import { render, staticRenderFns } from "./Gclqd.vue?vue&type=template&id=472be1b5&scoped=true"
import script from "./Gclqd.vue?vue&type=script&lang=js"
export * from "./Gclqd.vue?vue&type=script&lang=js"
import style0 from "./Gclqd.vue?vue&type=style&index=0&id=472be1b5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472be1b5",
  null
  
)

export default component.exports